"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseAuth = void 0;
var FirebaseAuth;
(function (FirebaseAuth) {
    FirebaseAuth["AppDeleted"] = "auth/app-deleted";
    FirebaseAuth["NotAuthorized"] = "auth/app-not-authorized";
    FirebaseAuth["ArgumentError"] = "auth/argument-error";
    FirebaseAuth["InvalidApiKey"] = "auth/invalid-api-key";
    FirebaseAuth["InvalidTenantId"] = "auth/invalid-tenant-id";
    FirebaseAuth["InvalidUserToken"] = "auth/invalid-user-token";
    FirebaseAuth["NetworkRequestFailed"] = "auth/network-request-failed";
    FirebaseAuth["OperationNotAllowed"] = "auth/operation-not-allowed";
    FirebaseAuth["RequiresRecentLogin"] = "auth/requires-recent-login";
    FirebaseAuth["TooManyRequests"] = "auth/too-many-requests";
    FirebaseAuth["UnauthorizedDomain"] = "auth/unauthorized-domain";
    FirebaseAuth["UserDisabled"] = "auth/user-disabled";
    FirebaseAuth["UserTokenExpired"] = "auth/user-token-expired";
    FirebaseAuth["WebStorageUnsupported"] = "auth/web-storage-unsupported";
})(FirebaseAuth = exports.FirebaseAuth || (exports.FirebaseAuth = {}));
//# sourceMappingURL=firebase.js.map